import faqSchema from '../schemas/faq';
import breadcrumbSchema from '../schemas/breadcrumb';
import itemlistSchema from '../schemas/itemlist';
import searchbox from '../schemas/searchbox.json';

const goalSchema = (faqs, goalName, goalURL, items, description) => {
  const breads = [
    {
      name: 'Explore',
      url: 'https://unacademy.com/explore'
    },
    {
      name: goalName,
      url: goalURL
    }
  ];

  const courses =
    items.filter((item) => item.type === 'special_classes')?.[0]?.data || [];

  const itemListElement = courses.map((course, index) => ({
    '@type': 'Course',
    '@id': course.permalink,
    position: index + 1,
    name: course.name,
    url: course.permalink,
    about: course.description || course.name,
    description: course.description || course.name,
    thumbnailUrl: course.cover_photo || course.thumbnail,
    courseCode: course.uid,
    accessMode: ['auditory', 'visual'],
    isAccessibleForFree: course.forPlus ? 'False' : 'True',
    inLanguage: course.language_display,
    provider: {
      '@type': 'Organization',
      name: 'Unacademy',
      sameAs: 'https://unacademy.com/'
    }
  }));

  const schema = {
    '@context': 'https://schema.org/',
    '@graph': [
      faqSchema(faqs),
      searchbox,
      breadcrumbSchema(breads),
      itemlistSchema(description, itemListElement)
    ]
  };

  return schema;
};

export default goalSchema;
